export const headersByFieldNames = {
  select_row: 'SELECT_ROW',
  number: 'PAYOUT_NUMBER',
  date_created: 'DATE_CREATED',
  due_date: 'DUE_DATE',
  carrier_name: 'CARRIER',
  total: 'TOTAL',
  type: 'SHIPMENT_TYPE',
  status: 'STATUS',
  payment_method: 'PAYMENT_METHOD',
  payment_terms: 'PAYMENT_TERMS',
  auto_pay_enabled: 'STRIPE_ENABLED',
  authorization: 'CARRIER_AUTHORIZATION',
  actions: 'ACTIONS',
};
